import React, { useState, useEffect  } from 'react';
import { ChevronLeft, ChevronRight, LogIn, ChevronDown } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './HomePage.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer';
import About from '../Navbar/About';
import FivePillars from '../Navbar/FivePillars';
import approachLogo from '../../assets/approach.png'; // Add your logos
import differentiatorLogo from '../../assets/Differentiator.png';
import methodologyLogo from '../../assets/methodology.png';
import dataAnalysisLogo from '../../assets/analysis.png';
import slider1 from '../../assets/slider1.png';
import slider2 from '../../assets/slider2.png';
import slider3 from '../../assets/slider3.png';
import slider4 from '../../assets/slider4.png';
const HomePage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [currentSlide, setCurrentSlide] = useState(0);
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollToAbout) {
            const aboutSection = document.getElementById('about-section');
            aboutSection?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        if (location.state?.scrollToPillars) {
            const pillarsSection = document.getElementById('pillars-section');
            pillarsSection?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [location.state]);



    const images = [
        {
            src: slider1,
            title: 'Confusion to Clarity',
            description: 'Uniaariv empower you to discover yourself, align your uniqueness, strengths etc. with your natural inclination, unlock fullest potential' +
                ' and step into a future that’s truly yours (the field/sector) to do, be, succeed and live an accomplished life.',
        },
        {
            src: slider2,
            title: 'Limited Perspective to Deep Insights', // Unique title for the second image
            description: 'Empower CHRO to make unbiased informed decision, cultivate high performance culture, Future-proof organization by early identification,' +
                ' nurturing potential leaders and avoiding potential ethical and moral challenges.',
        },
        {
            src: slider3,
            title: 'Complexity to Simplicity',
            description: '',
        },
        {
            src: slider4,
            title: '',
            description: 'All our training programs are designed by blending modern science with universal science, the laws of nature, the depth and dimensions of life,' +
                ' existential realities, and real-life personal and professional experiences. Our endeavor is not just to transfer knowledge (information) but also to help you' +
                ' understand it from different perspectives and experience it first hand.',
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide]);

    const nextSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === images.length - 1 ? 0 : prevSlide + 1
        );
    };

    const prevSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === 0 ? images.length - 1 : prevSlide - 1
        );
    };


    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    return (
        <div className="home-page">
            <Navbar />
            <div className="hero-slider">
                {/*<h1>{images[currentSlide].title}</h1>*/}
                <button className="slider-btn prev" onClick={prevSlide}>
                    <ChevronLeft size={24} />
                </button>
                <div className="slider-container">
                    {images.map((image, index) => (
                        <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                            <img src={image.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            <div className="slide-content">
                                <p>{image.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="slider-btn next" onClick={nextSlide}>
                    <ChevronRight size={24} />
                </button>


            {/* Take Assessment Button */}
            <div className="take-assessment-container">
                <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                    Take Assessment
                    <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
            </div>

            <FivePillars />

            {/* WHY CHOOSE UNIAARIV Section */}
            <div className="why-choose-section">
                <h2>WHY CHOOSE UNIAARIV</h2>
                <div className="features-container">
                    <div className="feature">
                        <img src={approachLogo} alt="Approach" />
                        <h3>Approach</h3>
                        <p>Our approach is free from bias, subjective experiential learning, and survey-based results as we apply a blend of modern science, applied holistic Universal Human Science and Psychology, and the Law of Nature.</p>
                    </div>
                    <div className="feature">
                        <img src={differentiatorLogo} alt="Differentiator" />
                        <h3>Differentiator</h3>
                        <p>Our holistic three-dimensional and five-pillars approach captures three colors of the mind and digs out deep-rooted true intrinsic nature (hummock) unlike superficial symptomatic, subjective, and behavioral aspects (tip of the iceberg) of say DMIT that too is denounced by the IPS.</p>
                    </div>
                    <div className="feature">
                        <img src={methodologyLogo} alt="Proprietary Methodology" />
                        <h3>Proprietary Methodology</h3>
                        <p>TrueIn© assessment is developed by extensive research of over 5 years of universal literature used by scientists and top leaders and over 50 years of experience and collective wisdom.</p>
                    </div>
                    <div className="feature">
                        <img src={dataAnalysisLogo} alt="Data Analysis" />
                        <h3>Data Analysis</h3>
                        <p>Our comprehensive Report covers quantitative scores on 20 key parameters, EQ, MQ, LQ, and a SWOT analysis, hence not just easy to understand but easy for use in quick and unbiased decisions.</p>
                    </div>
                </div>
            </div>
            <About/>

            <div className="get-started-section">
                <div className="get-started-container">
                    <h2>Get Started with UNIAARIV</h2>
                    <p className="get-started-description">
                        Are you ready to take the next step in your personal or professional journey?
                    </p>
                    <p className="get-started-subtext">
                        Whether you're a student seeking direction or an organization facing complex HR challenges,
                        UNIAARIV is here to guide you with scientifically-backed, unbiased insights or a banker
                        of NBFC striving to optimize credit risk.
                    </p>

                    <div className="transition-list">
                        <h3>Let us help you transition from:</h3>
                        <ul>
                            <li>Confusion to clarity</li>
                            <li>Limited perspective to Deep insights for addressing HR challenges</li>
                            <li>Complexity to simplicity to Optimize Credit/Loan Default risk</li>
                            <li>A journey from knowledge to wisdom in empowering your employees</li>
                        </ul>
                    </div>

                    <div className="take-assessment-container">
                        <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                            Get Started
                            <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    fillRule="evenodd"
                                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>


            <Footer />
        </div>
    );
};



export default HomePage;